export default __webpack_public_path__ + "static/media/hackingheist.131feb25.md";